import { render } from "./BackendLogsContent.vue?vue&type=template&id=cb87dd22&scoped=true"
import script from "./BackendLogsContent.vue?vue&type=script&lang=js"
export * from "./BackendLogsContent.vue?vue&type=script&lang=js"

import "./BackendLogsContent.vue?vue&type=style&index=0&id=cb87dd22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb87dd22"]])

export default __exports__